module.exports = __webpack_public_path__ + "7328f6f7601e6a3a67a8ecbf6e8e80ee.svg";